import { PageResult } from '@/api/typing';
import ls, { remoteSelectStore } from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { message } from 'ant-design-vue';

const obj2json = (obj: any): string => {
  if (obj instanceof Array) {
    return obj.join();
  } else if (obj instanceof Object) {
    return JSON.stringify(obj);
  } else {
    return obj.toString();
  }
};

const obj2str = (obj: any): string => {
  if (obj instanceof Array) {
    return obj.join();
  } else if (obj instanceof Object) {
    return Object.keys(obj)
      .sort((a, b) => a.localeCompare(b))
      .map((key: string) => {
        return `${key}-${obj2json(obj[key])}`;
      })
      .join();
  } else {
    return JSON.stringify(obj);
  }
};

export default (api_fun: any, api_url?: string): any => {
  const fun = (params: Record<string, any>, noCache?: boolean): Promise<PageResult> => {
    const org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const paramsKey = Object.keys(params)
      .sort((a, b) => a.localeCompare(b))
      .map((key: string) => {
        return `${key}-${obj2str(params[key])}`;
      })
      .join();
    const time = new Date().getTime() + 3600 * 1000;
    const obj = remoteSelectStore.get(`${org?.id}_${api_url}`);

    return new Promise(resolve => {
      if (!noCache && obj && obj.time > new Date().getTime() && obj.paramsKey == paramsKey) {
        resolve(obj.data);
      } else {
        api_fun(params)
          .then((res: any) => {
            remoteSelectStore.set(`${org?.id}_${api_url}`, {
              data: res,
              time: time,
              paramsKey: paramsKey,
            });
            resolve(res);
          })
          .catch(() => {
            message.destroy();
            message.error('接口调用失败', 10);
          });
      }
    });
  };
  return fun;
};
